import { render, staticRenderFns } from "./contDialog.vue?vue&type=template&id=1ba4d12d&scoped=true&"
import script from "./contDialog.vue?vue&type=script&lang=js&"
export * from "./contDialog.vue?vue&type=script&lang=js&"
import style0 from "./contDialog.vue?vue&type=style&index=0&id=1ba4d12d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba4d12d",
  null
  
)

export default component.exports